import { Link } from 'react-router-dom';
import { Breadcrumb } from './useBreadcrumbs';
import classes from './Breadcrumbs.module.css';

type BreadcrumbItemProps = {
  breadcrumb: Breadcrumb;
  isCurrent: boolean;
};

export const BreadcrumbItem = ({ breadcrumb, isCurrent }: BreadcrumbItemProps) => (
  <li className={classes.item}>
    {isCurrent ? (
      <span className={classes.current} aria-current="page">
        {breadcrumb.label}
      </span>
    ) : (
      <Link to={breadcrumb.path} className={classes.link}>
        {breadcrumb.label}
      </Link>
    )}
  </li>
);
